import { useCallback, useState } from 'react';

import { S3Object } from '../../../drive/types';
import { getDisplayName } from '../helpers';

export interface UseSearchOperationsReturn {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  clearSearch: () => void;
  filterObjects: (objects: S3Object[]) => S3Object[];
}

export const useSearchOperations = (): UseSearchOperationsReturn => {
  const [searchQuery, setSearchQuery] = useState('');

  const clearSearch = useCallback(() => {
    setSearchQuery('');
  }, []);

  const filterObjects = useCallback(
    (objects: S3Object[]): S3Object[] => {
      if (!searchQuery.trim()) {
        return objects;
      }

      const query = searchQuery.trim().toLowerCase();

      return objects.filter((obj) => {
        if (!obj.Key) return false;

        const displayName = getDisplayName(obj.Key);
        return displayName.toLowerCase().startsWith(query);
      });
    },
    [searchQuery]
  );

  return {
    searchQuery,
    setSearchQuery,
    clearSearch,
    filterObjects,
  };
};
